import React, { useEffect, useState } from 'react'

import { SingleSelect } from '../Select'

import apiClient from '../../helpers/apiClient'

const SingleCurrencySelect = ({
  currency,
  onSelectCurrency,
  validationError,
}) => {
  const [currencyList, setCurrencyList] = useState([])

  useEffect(() => {
    apiClient
      .get(`/currencies`)
      .then((res) => {
        setCurrencyList(
          res?.data?.data?.map((e) => ({
            value: e.currency,
            label: e.currency,
          }))
        )
      })
      .catch((err) => console.log(err))
  }, [])

  return (
    <SingleSelect
      title="Currency"
      selected={currency}
      options={currencyList}
      placeholder="Start typing a currency..."
      onChange={onSelectCurrency}
      wrapperClass={validationError && 'error'}
      subText={validationError}
    />
  )
}

export default SingleCurrencySelect
